
import $ from 'jquery';

console.log('Cookie Banner Activated');

window.get_cookie = function(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return "";
};

window.set_cookie = function(cname, cvalue, expiry) {
    let date = new Date();
    date.setTime(date.getTime() + expiry);
    let expires = "expires=" + date.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.delete_cookie = function(cname) {
    window.set_cookie(cname, null, -1);
};

window.has_cookie = function(cname) {
    return window.get_cookie(cname) !== '';
};

function close_cookie_banner() {
    $('#cookie-banner').addClass('is-closed');
}

function open_cookie_banner() {
    $('#cookie-banner').removeClass('is-closed');
}

function accept_cookies() {
    set_cookie('bcc_cookies_accepted', true);
    close_cookie_banner();
}

function reject_cookies() {
    set_cookie('bcc_cookies_accepted', false);
    close_cookie_banner();
}

$(document).on('click', '#accept-cookie-action', function() {
    accept_cookies();
});

$(document).on('click', '#reject-cookie-action', function() {
    reject_cookies();
});

$(document).on('click', 'a[href$="#cookie-preferences"]', function(event) {
    event.preventDefault();
    open_cookie_banner();
});
